import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { UpdateBoxInput, UpdateBoxOutput } from "types/web-app";

export const updateBox = async (accessToken: string, input: UpdateBoxInput) => {
  try {
    const response = await fetchWithAuth("/box/update", accessToken, {
      method: "POST",
      body: JSON.stringify(input),
    });
    const data = (await response.json()) as ServiceResponse<UpdateBoxOutput>;
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
